import { FC } from 'react';
import { usePagination } from '@features/Pagination';
import { useAsyncData } from '@shared/react';
import { getVerificationResults } from '../api';
import { getKYCTableColumns } from './getKYCTableColumns';
import { Table } from '@features/Table';
import { combineFilter } from '@shared/utils';
import './KYCRequests.scss';

interface IKYCRequests {
    clearingAccount: string;
}

export const KYCRequests: FC<IKYCRequests> = ({ clearingAccount }) => {
    const { page, pageSize, setTotalCount } = usePagination();
    const { data: verificationResults, loading: verificationResultsLoading } = useAsyncData(
        async () => {
            const filter = {
                clearingAccount,
            };
            const { items, totalResults } = await getVerificationResults({
                page: page,
                pageSize,
                filter: combineFilter(filter),
                sortBy: 'VerificationDate',
            });
            setTotalCount(totalResults);
            return items || [];
        },
        [],
        [page, pageSize],
    );

    return (
        <div className='kyc-requests'>
            <Table
                dataLoading={verificationResultsLoading}
                columns={getKYCTableColumns()}
                data={verificationResults}
            />
        </div>
    );
};
